import React from 'react';
import PropTypes from 'prop-types';
import WithGlobalUserInfo from './WithGlobalUserInfo';

function UserDisplayName({ user }) {
    return <span>{user.display_name}</span>;
}

UserDisplayName.propTypes = {
    user: PropTypes.object
}

UserDisplayName.defaultProps = {
    user: {}
}

export default WithGlobalUserInfo(UserDisplayName);